import React from "react";
import { useSelector } from "react-redux";

const UserProfileModal = ({ onClose }) => {
  const { details } = useSelector((state) => state.user);
  const appSumoSource =
    (details?.data?.source || "").toLowerCase() === "appsumo";
  const trial = details?.data?.trial;
  const onUpgradeClick = () => {
    if (appSumoSource) {
      return window.open("https://appsumo.com/account/products/", {
        target: "_blank",
      });
    }
    return window.open("/pricing/", { target: "_blank" });
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="bg-white p-6 rounded-lg w-96 z-10 max-h-[500px] overflow-auto">
        <h2 className="text-xl font-bold mb-4">User Profile</h2>

        <label className="block mb-4">
          <span className="text-gray-700">First name:</span>
          <input
            type="text"
            className="mt-1 p-2 w-full rounded border"
            value={details.first_name}
            readOnly
          />
        </label>
        <label className="block mb-4">
          <span className="text-gray-700">Last name:</span>
          <input
            type="text"
            className="mt-1 p-2 w-full rounded border"
            value={details.last_name}
            readOnly
          />
        </label>
        <label className="block mb-4">
          <span className="text-gray-700">Email:</span>
          <input
            type="email"
            className="mt-1 p-2 w-full rounded border"
            value={details.email}
            readOnly
          />
        </label>
        <label className="block mb-4">
          <span className="text-gray-700">Remaining Videos:</span>
          <input
            type="number"
            className="mt-1 p-2 w-full rounded border"
            value={details?.data?.videos}
            readOnly
          />
        </label>
        {/* <label className="block mb-4">
          <span className="text-gray-700">Remaining Minutes (up to):</span>
          <input
            type="number"
            className="mt-1 p-2 w-full rounded border"
            value={details?.data?.videos * 10}
            readOnly
          />
        </label> */}
        {/* <label className="block mb-4">
          <span className="text-gray-700">Maximum Slides:</span>
          <input
            type="number"
            className="mt-1 p-2 w-full rounded border"
            value={details?.data?.max_slides}
            readOnly
          />
        </label> */}
        <label className="block mb-4">
          <span className="text-gray-700">Total Custom Avatar:</span>
          <input
            type="number"
            className="mt-1 p-2 w-full rounded border"
            value={details?.data?.max_custom_avatar}
            readOnly
          />
        </label>
        {/* <label className="block mb-4">
          <span className="text-gray-700">HD avatar minutes:</span>
          <input
            type="number"
            className="mt-1 p-2 w-full rounded border"
            value={details?.data?.hd_videos_minutes || 0}
            readOnly
          />
        </label> */}

        <div className="flex justify-end mt-6">
          {trial && (
            <a
              href="/pricing"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 mr-2"
              onClick={onUpgradeClick}
            >
              Upgrade
            </a>
          )}
          <button
            className="border px-4 py-2 rounded hover:bg-gray-200"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserProfileModal;
